import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { useQaView } from "src/hooks/useQaView";
import { DeleteButton } from "src/components/Buttons";
import { YELLOW_ALERT } from "src/constants/colors";
import { useDealer } from "src/hooks/useDealer";

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
  padding: 16px 80px;
  background-color: ${YELLOW_ALERT};
`;

export default function () {
  const { exit } = useQaView();
  const navigate = useNavigate();
  const { enabled: qaViewEnabled } = useQaView();
  const { dealer_id } = useDealer();

  const handleExit = () => {
    exit();
    void navigate(`/${dealer_id}/dashboard?refresh=${Date.now()}`, {
      replace: true,
    });
  };

  if (!qaViewEnabled) return null;

  return (
    <Container>
      <h2>QA Mode is Active</h2>
      <DeleteButton initialBg={true} onClick={handleExit}>
        Exit QA View
      </DeleteButton>
    </Container>
  );
}
